import { validateEmail } from 'utils'
export const data = {
  fieldsById: {
    email: {
      type: `text`,
      placeholder: `Ingresa tu e-mail`,
      value: undefined,
      useNameInsteadId: true,
      useOnChangeInsteadOnBlur: true,
      fullWidth: true,
      rules: {
        required: true,
        min: 7,
        max: 50,
        validations: [
          {
            field: false,
            validateFunction: (val, current) => {
              return validateEmail(current)
            },
            error: `Ingrese un email válido`,
          },
        ],
      },
    },
    password: {
      type: `password`,
      placeholder: `Ingresa tu contraseña`,
      value: undefined,
      useNameInsteadId: true,
      useOnChangeInsteadOnBlur: true,
      fullWidth: true,
      icon: `visibility`,
      rules: {
        required: true,
        min: 0,
        max: 255,
      },
    },
    forgot_password: {
      type: `link`,
      label: `He olvidado mi contraseña`,
      target: `_black`,
      value: `https://registro.sernatur.cl/registroempresarios/recover`,
    },
  },
  sections: {
    fieldsIds: [`email`, `password`, `forgot_password`],
  },
}
